<template>
  <div>
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <h4 class="title is-4">{{ createOrUpdate }}</h4>
    <div class="columns">
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Company</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              v-model="client.company"
            />
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Contact name</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              v-model="client.contactName"
            />
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Contact title</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              v-model="client.contactTitle"
            />
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Address</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              v-model="client.address"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Phone</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="client.phone" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Local 1</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="client.local" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Local 2</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="client.local" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">FAX</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="client.fax" />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Email</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="client.email" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Payment method</label>
          <div class="select is-small">
            <select v-model="client.paymentMethod">
              <option value="0">Cash</option>
              <option value="1">Check</option>
              <option value="2">Card</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">TIN</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="client.tin" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Business Type</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              v-model="client.businessType"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">OSCA</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="client.osca" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Include Less Vat</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              v-model="client.includeLessVat"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Include Vat Exemption</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              v-model="client.includeVatEx"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Include Vat Inc</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              v-model="client.includeVatInc"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">City</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="client.city" />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Terms</label>
          <div class="select is-small">
            <select v-model="client.term">
              <option value="0">Cash</option>
              <option value="1">Dated Check</option>
              <option value="2">Cash/Dated Check</option>
              <option value="3">7 Days</option>
              <option value="4">15 Days</option>
              <option value="5">21 Days</option>
              <option value="6">30 Days</option>
              <option value="7">30 Days PDC</option>
              <option value="8">45 Days</option>
              <option value="9">60 Days</option>
              <option value="10">1 Year</option>
              <option value="11">Cash on Delivery</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small"
            >Assigned Agent (Optional restriction)</label
          >
          <div class="control" v-if="hasAdminSalesAndMainAdminPriv">
            <b-autocomplete
              v-model="agentName"
              size="is-small"
              :data="agents"
              placeholder="Search user agent"
              @select="option => (selectedUser = option)"
              @input="searchUserAgents"
            >
              <template slot="empty">
                <span v-if="isFetchingUserAgents">
                  Please wait...
                </span>
                <span v-if="agents.length === 0">
                  No results found
                </span>
              </template>
            </b-autocomplete>
          </div>
          <div class="control" v-else>
            <span v-if="createOrUpdate === 'Edit'">
              <input class="input is-small" v-model="agentName" readonly />
            </span>
            <span v-else>
              <input class="input is-small" readonly value="AUTO ASSIGN" />
            </span>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Status</label>
          <div class="control">
            <b-switch
              size="is-small"
              v-model="activeStatus"
              :disabled="!hasAdminPriv"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="columns"
      v-if="
        createOrUpdate === 'Edit' &&
          client.clientId &&
          client.isDeleted === true &&
          !hasAdminPriv
      "
    >
      <div class="column is-12">
        <span class="has-text-danger">
          * The status of this client is set to inactive. Please contact the
          Main Admin if you want to enable this client.
        </span>
        <p style="font-weight: bold">
          Possible reasons why this client becomes inactive:
        </p>
        <span>
          <ol>
            <li>
              A newly created client that requires admin to set this to active
              status.
            </li>
            <li>
              You just recently updated this client that changed the term. If
              the agent made a changes to the term, then the status becomes
              inactive and requires the re-approval from Main Admin.
            </li>
            <li>The agent or admin set this as inactive.</li>
          </ol>
        </span>
      </div>
    </div>
    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <button :class="buttonSave" @click="saveClient">Save</button>
        &nbsp;
        <router-link :to="{ name: 'List of Clients' }" class="button is-small"
          >Go back to list</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";
import AuthService from "../../_services/auth";

const appToast = new AppToast();
const appButton = new AppButton();
const authService = new AuthService();

export default {
  data: () => ({
    hasAdminSalesAndMainAdminPriv: authService.hasAdminSalesAndMainAdminPriv(),
    hasAdminPriv: authService.hasAdminPriv(),
    createOrUpdate: "Create",
    isFullPage: true,
    isLoading: false,
    buttonSave: appButton.isLoadingSuccess(false),
    activeStatus: false,
    client: {
      paymentMethod: 0,
      term: 0
    },
    // search user agent
    agentName: "",
    agents: [],
    selectedUser: 0,
    isFetchingUserAgents: false
  }),
  created() {
    const clientId = this.$route.params.clientId;
    if (clientId) {
      this.getClientById(clientId);
    }
  },
  watch: {
    selectedUser() {
      if (this.selectedUser.id) {
        this.client.id = this.selectedUser.id;
        this.agentName = this.selectedUser.value;
      } else {
        this.selectedUser = 0;
        this.agentName = "";
      }
    }
  },
  methods: {
    default() {
      this.client = {
        term: 0
      };
    },
    searchUserAgents() {
      axios
        .get(`api/users/ac/by-name/${this.agentName}`)
        .then(response => {
          this.agents = response.data;
        })
        .catch(error => console.log(error.response));
    },
    getClientById(id) {
      this.createOrUpdate = "Edit";
      this.isLoading = true;
      axios
        .get(`api/clients/${id}`)
        .then(response => {
          this.client = response.data;
          this.agentName = response.data.user;
          if (this.client.isDeleted) {
            this.activeStatus = false;
          } else {
            this.activeStatus = true;
          }
        })
        .catch(error => console.log(error))
        .then(() => (this.isLoading = false));
    },
    saveClient() {
      this.buttonSave = appButton.isLoadingSuccess(true);
      const clientId = this.client.clientId;
      if (this.activeStatus) {
        this.client.isDeleted = false;
      } else {
        this.client.isDeleted = true;
      }
      if (clientId) {
        // Edit
        axios
          .put(`api/clients/${clientId}`, this.client)
          .then(response => {
            appToast.success(response.data);
          })
          .catch(error => {
            appToast.danger(error.response.data);
            console.log(error.response);
          })
          .then(() => {
            this.buttonSave = appButton.isLoadingSuccess(false);
            this.getClientById(clientId)
          });
      } else {
        axios
          .post(`api/clients`, this.client)
          .then(response => {
            appToast.success(response.data);
            this.default();
          })
          .catch(error => {
            console.log(error.response);
            appToast.danger(error.response.data);
          })
          .then(() => {
            this.buttonSave = appButton.isLoadingSuccess(false);
          });
      }
    }
  }
};
</script>
